module.exports = __webpack_public_path__ + "static/media/img_bg.858f1ec6.svg";